import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=22a14df0&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./RedirectPage.vue?vue&type=style&index=0&id=22a14df0&lang=less&scoped=true&"
import style1 from "./RedirectPage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a14df0",
  null
  
)

export default component.exports